/* @flow */
import React from 'react';

import Avatar from 'components/Avatar.jsx';
import type { ChatTypeType } from 'entities/Chat';
import { TYPES } from 'entities/Chat';

type Props = {
  chatColor?: string,
  otherMemberInitials: string,
  otherMemberColor: string,
  inactive: boolean,
  chatType: ?ChatTypeType,
  activityStartAt: ?Date,
};

// This has to be 'any' because something about Flow
const TYPE_TO_GLYPH: any = {
  [TYPES.ACTIVITY]: 'message-activity',
  [TYPES.GROUP]: 'message-group',
  [TYPES.INDIVIDUAL]: undefined,
};

export default function ({
  chatColor,
  otherMemberInitials,
  otherMemberColor,
  inactive,
  chatType,
  activityStartAt,
  }: Props) { // eslint-disable-line object-curly-spacing
  let text;

  let colorHex = chatColor || otherMemberColor;

  if (inactive || !colorHex) {
    colorHex = 'ADADAD'; // Eclipse
  }


  if (chatType === TYPES.ACTIVITY && activityStartAt) {
    return <Avatar colorHex={colorHex} date={activityStartAt} size="medium" />;
  }

  if (chatType === TYPES.INDIVIDUAL) {
    text = otherMemberInitials;
  }

  const glyph = TYPE_TO_GLYPH[chatType];

  return (
    <Avatar
      glyphName={glyph}
      colorHex={colorHex}
      text={text || undefined}
      size="medium"
    />
  );
}



// WEBPACK FOOTER //
// ./src/chat/components/ChatListItemAvatar.jsx